export function getSettingInfo(state, props) {
    return state.setting
}

export function getADSuccess(state, props) {
    return state.AD
}

export function getTimezone(state, props) {
    return state.timezone
}

export function getIsTMS(state, props) {
    return state.TMS
}

export function getIsCMR(state, props) {
    return state.CMR
}


export function getIsBOT(state, props) {
    return state.BOT
}


// WEBPACK FOOTER //
// ./src/features/setting/selectors.js